import React from "react";
const GalleryCom = (props) => {
  return (
    <div
      className={`flex justify-center flex-col items-center ${props.layout}`}
      style={{ backgroundColor: props.bgcolor }}
    >
      <img
        src={props.latestNewsthubmail}
        className={`${props.Img}`}
        alt={props.alt}
      />
    </div>
  );
};
export default GalleryCom;
